export default "__VITE_ASSET__BMswtryx__"